import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { ATTACHMENT_LEVEL } from "constants/generalConstants";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setDisableCopy,
    updateAvailableAttachmentsToCopyAction,
} from "redux/actions/attachmentActions";
import { tableHeaderProps } from "styled/props/tableProps";

export default function AttachmentListDialog() {
    const dispatch = useDispatch();

    const listOfAttachments = useSelector(
        (state) => state.attachment.availableAttachmentsToCopy
    );

    useEffect(() => {
        const isAnyAttachmentSelectedToCopy =
            listOfAttachments.filter((a) => a.isSelectedToCopy && !a.isCopied)
                .length > 0;

        // Disable the copy button in following scenarios
        // 1. If no attachments selected to copy
        // 2. if the selected attachments are already copied
        dispatch(setDisableCopy(!isAnyAttachmentSelectedToCopy));
    }, [listOfAttachments]);

    const handleRowCheckboxClick = (e) => {
        const { value: attachment_id, checked } = e.target;

        // value is attachment_id
        dispatch(
            updateAvailableAttachmentsToCopyAction([attachment_id], {
                isSelectedToCopy: checked,
            })
        );
    };

    const handleHeaderCheckboxClick = (e) => {
        const { checked } = e.target;
        dispatch(
            updateAvailableAttachmentsToCopyAction(
                listOfAttachments.map((a) => a.ATTACHMENT_ID),
                {
                    isSelectedToCopy: checked,
                }
            )
        );
    };

    const isAllAttachmentsCopied =
        listOfAttachments.length > 0 &&
        listOfAttachments.length ===
            listOfAttachments.filter((a) => a.isCopied).length;

    const isAllAttachmentsSelected =
        listOfAttachments.length > 0 &&
        listOfAttachments.length ===
            listOfAttachments.filter((a) => a.isSelectedToCopy).length;

    const isHeaderIndeterminateState =
        !isAllAttachmentsSelected &&
        listOfAttachments.filter((a) => a.isSelectedToCopy).length > 0;

    const disabledColor = (isDisabled) => {
        return isDisabled ? "gray" : "inherit";
    };

    return (
        <>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead sx={{ color: "black" }}>
                            <TableRow style={{ height: "7px" }}>
                                <TableCell
                                    style={{
                                        width: "10%",
                                        padding: "3px",
                                    }}
                                >
                                    <Typography {...tableHeaderProps}>
                                        <Checkbox
                                            checked={isAllAttachmentsSelected}
                                            indeterminate={
                                                isHeaderIndeterminateState
                                            }
                                            onClick={handleHeaderCheckboxClick}
                                            disabled={isAllAttachmentsCopied}
                                        />
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: "20%",
                                        padding: "3px",
                                    }}
                                >
                                    <Typography {...tableHeaderProps}>
                                        Type
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: "35%",
                                        padding: "3px",
                                    }}
                                >
                                    <Typography {...tableHeaderProps}>
                                        Name
                                    </Typography>
                                </TableCell>
                                <TableCell
                                    style={{
                                        width: "35%",
                                        padding: "3px",
                                    }}
                                >
                                    <Typography {...tableHeaderProps}>
                                        Category
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listOfAttachments.length > 0 &&
                                listOfAttachments.map(
                                    (fileAttachment, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    padding: "3px",
                                                }}
                                            >
                                                <Checkbox
                                                    value={
                                                        fileAttachment.FILE_ID
                                                    }
                                                    checked={
                                                        fileAttachment.isSelectedToCopy ||
                                                        fileAttachment.isCopied
                                                    }
                                                    onChange={
                                                        handleRowCheckboxClick
                                                    }
                                                    disabled={
                                                        fileAttachment.isCopied
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    padding: "3px",
                                                    color: disabledColor(
                                                        fileAttachment.isCopied
                                                    ),
                                                }}
                                            >
                                                {fileAttachment.LEVEL_TYPE ===
                                                ATTACHMENT_LEVEL.LINE
                                                    ? fileAttachment.LEVEL_TYPE +
                                                      " " +
                                                      (fileAttachment.LINE_NUM +
                                                          1)
                                                    : fileAttachment.LEVEL_TYPE}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    padding: "3px",
                                                    whiteSpace: "normal",
                                                    overflowWrap: "break-word",
                                                    wordBreak: "break-all",
                                                    color: disabledColor(
                                                        fileAttachment.isCopied
                                                    ),
                                                }}
                                            >
                                                {fileAttachment.FILENAME}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{
                                                    padding: "3px",
                                                    color: disabledColor(
                                                        fileAttachment.isCopied
                                                    ),
                                                }}
                                            >
                                                {Array.isArray(
                                                    fileAttachment.CATEGORY
                                                )
                                                    ? fileAttachment.CATEGORY.join(
                                                          ","
                                                      )
                                                    : fileAttachment.CATEGORY ??
                                                      ""}
                                            </TableCell>
                                        </TableRow>
                                    )
                                )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </>
    );
}
